import React from "react";
import { Row, Col, Typography } from "antd";
import SocialLogins from "components/Authentication/Common/SocialLogins";
import styles from "components/Authentication/Common/auth.module.css";
import Footer from "components/Authentication/Common/Footer";
import { Link } from "react-router-dom";

const SigninWrapper = ({ children, withSocial = true }) => {
  return (
    <React.Fragment>
      <Row className={`${styles.parentContainer}`}>
        <Col lg={{ span: 8 }} sm={{ span: 9 }} className={`d-flex align-items-center justify-content-center ${styles.container}`}>
          <div className={`${styles.formContainer}`}>
            <div className="d-md-none text-center w-100">
              <img src="./images/Guni_logo.png" alt="guni-logo" className={`${styles.guniLogo} m-0 mb-4`} />
            </div>
            <Typography.Title level={2} className="mb-1">
              Sign In
            </Typography.Title>
            <Typography.Title level={4} className="mt-0 mb-4 fs-6 text-muted">
              to stay connected with us
            </Typography.Title>
            {children}
            {withSocial && (
              <>
                <div className="w-100 d-flex justify-content-around align-items-center mb-3">
                  <hr className="w-100" />
                  <span className="mx-2 text-muted">OR</span>
                  <hr className="w-100" />
                </div>
                <SocialLogins />
              </>
            )}
            <div className="w-100 my-4">
              <Typography.Text>
                New to Guni?{" "}
                <Link to="/signup" className="text-info-color" style={{ fontSize: "medium" }}>
                  &nbsp;&nbsp;Sign up
                </Link>
              </Typography.Text>
            </div>
            <Footer />
          </div>
        </Col>
        <Col lg={{ span: 16 }} sm={{ span: 15 }} className={`d-none d-md-flex ${styles.imageContainer}`}>
          <div className="w-100">
            <img src="./images/Guni_logo.png" alt="guni-logo" className={`${styles.guniLogo}`} />
          </div>
          <img src="./images/signin.svg" alt="guni-sign-in" className={`${styles.signInLogo}`} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SigninWrapper;
